<header class="page-header">
  <div>
    <h1 class="page-title">{{ 'pages.profiles.title' | translate }}</h1>
    <p class="page-subtitle">{{ 'pages.profiles.subtitle' | translate }}</p>
  </div>

  <button class="btn btn-primary" type="button" (click)="requestCreate()">
    <i class="fa-solid fa-plus" aria-hidden="true"></i>
    {{ 'pages.profiles.actions.create' | translate }}
  </button>
</header>
